/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row, Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as BoxesActions from '../../../actions/EpikBoxes';
import * as UserActions from '../../../actions/User';
import { addStep, popStep } from '../../../actions/Breadcrumbs';
import EpikboxPhones from './BoxPortTabs/EpikBoxPhones';
import EpikboxPorts from './BoxPortTabs/EpikBoxPorts';
import EpikboxOptions from './BoxPortTabs/EpikboxOptions';
import EpikboxPri from './BoxPortTabs/EpikboxPri';
import EpikboxObis from './BoxPortTabs/EpikBoxObis';
import BoxPortTabs from './BoxPortTabs';
import EpikBoxSipPir from './BoxPortTabs/EpikboxSipPri';
import LockIcon from '../../../Res/Icon/lock.png';
import AddTime from '../../../Res/Icon/addTime.png';
import portActivityIcon from '../../../Res/Icon/portActivityIcon.png';
import Release from '../../../Res/Icon/releaseLock.png';
import UnLockIcon from '../../../Res/Icon/unlocked.png';
import bandManagement from '../../../Res/Icon/bandManagement.png';
import SpinnerCircles from '../../Spinner/SpinerCircles';
import Spinner from '../../Spinner/Spinner';
import CallFeaturesModal from '../../CallFeaturesModal';
import { toast } from 'react-toastify';
import * as FaxActions  from '../../../actions/Fax';
import { default as DeleteBoxEpiModal } from '../../DeleteBoxEpiModal';
import {
  deleteAction,
  resetBulkBoxSession,
  sendBulkActionsToApi,
  enableAction,
  disableAction,
  changeAction,
  addAction,
} from '../../../actions/BoxSessionLogging';

import { getNumbers as getCompanyNumbers, getAllNumbers } from '../../../actions/Numbers';
import AdminTools from './BoxPortTabs/AdminTools';
import EpikboxNetworking from './BoxPortTabs/EpikboxNetworking';
import AddSecurityCodeModal from '../../AddSecurityCodeModal';
import CdrAnalyticsModal from '../../CdrAnalyticsModal';
import BandManagementModal from '../../BandManagementModal';
import TooltipIcon from './TooltipIcon/TooltipIcon';

import RemainingTimer from './RemainingTimer';
import { userRoles, bandModelWindowsOption } from '../../../utils/constants';


export class BoxPortingDetails extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken') || null;
    this.state = {
      modalStatus: false,
      twoFaRes: null,
      cdrAnalytics: false,
      boxCdrs: [],
      isActivityRowSelected: false,
      boxActivityLogs: null,
      addToolOpen: false,
      releaseToolOpen: false,
      portActivityOpen: false,
      bandManagementModal: false,
      loading: false,
      bandModelWindow: bandModelWindowsOption.faInput,
      showBandManagementIcon: false,
      oobLoading: false,
      releaseDeviceLock: false,
      oobSavedProfiles: {},
      CallFeatures:false,
      callFeatureBoxDetails:null,
      bandUserData: null,  
      pendingFaxData: [],
    };
    this.BoxReleasetimer = null;
    this.checktTimer = false;
    const { setState } = this.props;
    setState({
      portMode: props.user.company.companyType !== 'manufacturer' ? 'ports' : 'phones',
    });
  }
  fetchPendingFaxes = async () => {
    const { boxDetails, getAllPendingFaxes } = this.props;
    if (!boxDetails?.serialNumber) return;
    try {
      const response = await getAllPendingFaxes(this.token, {
        box: boxDetails?.serialNumber,
      });
      this.setState({
        pendingFaxData: response || [],
      });
    } catch (error) {
      this.setState({
        pendingFaxData: [],
      });
    }
  };

  CallFeaturesModal = async () => {
    const { boxDetails, getBoxDetailById } = this.props;
    const { _id, serialNumber } = boxDetails;
    const res= await this.props.getLiveCallFeature(this.token, _id);
    if (res) {
      toast.success('Call Features live data fetched');
    }
    else {
      toast.info('Call Features live data not fetched');
    }
    this.setState({
      CallFeatures: true,
      loading: true,
    });

    const boxData = await getBoxDetailById(this.token, boxDetails);
    this.setState({
      callFeatureBoxDetails: boxData,
      loading: false,
    });
  };
  componentDidUpdate(prevProps) {
    const { state } = this.props;
    if (this.checktTimer && prevProps.state.time !== state.time) {
      this.releaseBox(state.time);
      this.checktTimer = false;
    }
  }

  onImportConfirm = async () => {
    const { setImportNumbers, getBoxData, state } = this.props;
    const { importList } = state;
    const response = await setImportNumbers(this.token, importList);
    if (response) {
      addAction(`Import PRI porting Number ${importList?.length > 0 && importList}`);
    }
    setTimeout(() => {
      getBoxData();
    }, 1000);
  };

  portingNumbersArray = e => {
    const { boxDetails, setState, state } = this.props;
    const { importList } = state;
    e.forEach(item => {
      const newItem = { number: item, boxsn: boxDetails.serialNumber };
      importList.push(newItem);
    });
    setState({ importList });
  };

  checkSecurityCode = () => {
    if (this.state.modalStatus) {
      this.onDeleteBoxEpiConfirm();
    }
    this.setState({ modalStatus: false });
  };

  onDeleteBoxEpiConfirm = async () => {
    const { deleteEpikBoxEpi, boxEpiToDelete, getBoxData, deleteAction } = this.props;
    const res = await deleteEpikBoxEpi(this.token, boxEpiToDelete);
    if (res) {
      deleteAction(`Delete ${boxEpiToDelete._id} EPI box`);
    }
    getBoxData();
  };

  showPhonesModal = () => {
    const { getNumbers, boxDetails, showPhoneModal, setState, updatePhoneStatus } = this.props;
    setState({ phoneFormData: null });
    updatePhoneStatus(false);
    getNumbers(this.token, boxDetails.assignedTo._id);
    showPhoneModal();
  };

  onAvailableSave = async () => {
    const { setAssignedNumbers, boxDetails, getBoxData, state } = this.props;
    const { finalSelectedList } = state;
    await setAssignedNumbers(this.token, boxDetails._id, finalSelectedList);
    setTimeout(() => {
      getBoxData();
    }, 1000);
  };

  onModeSelect = async value => {
    const {
      boxDetails,
      unCheckPri,
      optionsBoxUpdate,
      resetBulkBoxSession,
      state,
      setState,
      updateEpikFields,
    } = this.props;
    const { enableBoxEdit, onOptionsStatus } = state;

    resetBulkBoxSession();
    setState({ portMode: value });
    if (value === 'options') {
      setState({ onOptionsStatus: true });
        this.fetchPendingFaxes();
    } else if (onOptionsStatus && enableBoxEdit) {
      setState({ isLoading: true });
      await updateEpikFields(optionsBoxUpdate);
      setState({ onOptionsStatus: false, isLoading: false });
      if (boxDetails.features.pri === false) {
        await unCheckPri(this.token, boxDetails._id);
      }
    }
  };
 
  handleBoxPhoneDetail = e => {
    const {
      user,
      getNumbers,
      boxDetails,
      showPhoneModal,
      setState,
      state,
      updatePhoneStatus,
    } = this.props;
    const { enableBoxEdit } = state;
    if (
      enableBoxEdit &&
      (user.role === 'superAdmin' ||
        user.role === 'companyGroupAdmin' ||
        user.role === 'supportEngineer')
    ) {
      updatePhoneStatus(true);
      setState({ phoneFormData: e });
      getNumbers(this.token, boxDetails.assignedTo._id);
      showPhoneModal();
    } else {
      console.log('not permitted');
    }
  };

  handleReloadEpi = async () => {
    const { reloadEpiInfo, getBoxData, setState } = this.props;
    const boxId = window.location.pathname.split('/').pop();
    setState({ loadingEPI: true });
    const res = await reloadEpiInfo(this.token, boxId);
    setState({ loadingEPI: false });
    if (res) {
      getBoxData();
    }
  };

  reloadObiBtn = loadingEPI => {
    return (
      <Button
        disabled={loadingEPI}
        className="reload-epi-btn"
        color="primary"
        onClick={this.handleReloadEpi}
      >
        {loadingEPI && <SpinnerCircles />}
        Reload EPI Info
      </Button>
    );
  };

  getBoxData = async () => {
    const { getBoxData } = this.props;
    await getBoxData();
  };

  renderPortOrObi = () => {
    const { props } = this;
    if (props.state.portMode === 'ports') {
      if (props.boxDetails.pendingMacAddresses && props.boxDetails.pendingMacAddresses.length > 0) {
        return (
          <>
            {this.reloadObiBtn(props.state.loadingEPI)}
            {[...props.boxDetails.pendingMacAddresses, ...props.boxDetails.pendingMacAddresses].map(
              (item, idx) => {
                return (
                  <div className="pendingMacAddressContainer pendingMacAddressPortContainer">
                    <div className="portLabel">
                      Port
                      {idx + 1}
                    </div>
                  </div>
                );
              },
            )}
          </>
        );
      }
      return (
        <EpikboxPorts
          box={props.boxDetails}
          numbers={props.numbers.allNumbers.docs}
          obis={props.boxDetails.Obis || []}
          onImportConfirm={this.onImportConfirm}
          importFinalList={this.portingNumbersArray}
          onAvailableSave={this.onAvailableSave}
          onAssignAvailablePress={this.onAssignAvailablePress}
          finalSelectedList={this.finalSelectedList}
          numberToFilter={this.numberToFilter}
          onSelect={async e => {
            if (
              props.state.enableBoxEdit &&
              ((props.user.role === 'superAdmin' ||
                props.user.role === 'supportEngineer' ||
                props.user.role === 'companyGroupAdmin' ||
                (props.user.role === 'admin' && e.assignedNumberRef) ||
                (props.user.role === 'enterpriseAdmin' && e.assignedNumberRef)
              )
              )) {
              props.selectPort(e);
            } else {
              console.log('not permitted');
            }
          }}
          onAtaSelect={e => {
            props.selectAta(e);
          }}
          selected={props.selectedPort}
          onSaveSip={props.onSaveSip}
          onBandManagementCall={this.onBandManagementCall}
          OOBManagerHandler={this.OOBManagerHandler}
          updateOOBDetail={this.updateOOBDetail}
          portMode={props.state.portMode}
          oobSavedProfiles={prof => this.setState({ oobSavedProfiles: prof })}
        />
      );
    }
    if (props.state.portMode === 'options') {
      return (
        <EpikboxOptions
          numbers={props.numbers.allNumbers.docs ?? props.numbers.allNumbers}
          onReboot={this.handleReboot}
          onApplyUpdate={props.onApplyUpdate}
          onFailoverInstall={this.onFailoverInstall}
          enableBoxEdit={props.state.enableBoxEdit}
          advancedMonitoring={this.setAdvancedMonitoring}
          enableToggleLoader={props.state.enableToggleLoader}
          advMonitoring={props.boxDetails.advancedMonitoring}
          onConfirm={props.updateEpikFields}
          priStatusCheck={this.priStatusCheck}
          eSIMStatusPing={this.eSIMStatusPing}
          bandManagementToggle={this.bandManagementToggle}
          showBandManagementIcon={this.state.showBandManagementIcon}
          bandManagementStatus={true}
          onBandManagementCall={this.onBandManagementCall}
          OOBManagerHandler={this.OOBManagerHandler}
          oobLoading= {this.state.oobLoading}
          oobLoadingHandler= {this.oobLoadingHandler}
          getAdminFlags={props.getAdminFlags}
          pendingFaxData={this.state.pendingFaxData}
        />
      );
    }
    if (props.state.portMode === 'pri' && props.boxDetails?.features?.showPriTab) {
      return (
        <EpikBoxSipPir
          enableBoxEdit={props.state.enableBoxEdit}
          box={props.boxDetails}
          onAvailableSave={this.onAvailableSave}
          onImportConfirm={this.onImportConfirm}
          importFinalList={this.portingNumbersArray}
          onConfirm={props.updateEpikFields}
          finalSelectedList={this.finalSelectedList}
          numberToFilter={this.numberToFilter}
          onAssignAvailablePress={this.onAssignAvailablePress}
          sipDetails={props.sipDetails}
        />
      );
    }
    if (props.state.portMode === 'networking') {
      return <EpikboxNetworking getBoxData={this.props.getBoxData}/>;
    }
    if (props.boxDetails.pendingMacAddresses && props.boxDetails.pendingMacAddresses.length > 0) {
      return (
        <>
          {this.reloadObiBtn(props.state.loadingEPI)}

          {props.boxDetails.pendingMacAddresses.map(item => {
            return (
              <div className="pendingMacAddressContainer">
                <div className="obiInfo">
                  <div className="infoLabel">
                    <FontAwesomeIcon fixedWidth className="labelIcon" icon="microchip" />
                    <h5>MAC Address</h5>
                  </div>
                  <span>{item.macAddress}</span>
                </div>
              </div>
            );
          })}
        </>
      );
    }
    if (props.state.portMode === 'adminTools') {
      return <AdminTools />;
    }
    return (
      <EpikboxObis
        obiReboot={props.obiReboot}
        enableBoxEdit={props.state.enableBoxEdit}
        box={props.boxDetails}
        obis={props.boxDetails.Obis || []}
        onSelect={props.selectObi}
        selected={props.selectedObi}
        rearrangeState={props.rearrangeEPIsState}
        rearrangedEpis={props.rearrangedEpis}
        openUnassignedObis={props.openUnassignedObis}
        showBoxConfig={props.showBoxConfig}
        onSetRearrange={props.setRearrangeEPIs}
        onCancelRearrange={props.cancelRearrangeEPIs}
        onBoxEpiDelete={props.showDeleteEpikBoxEpi}
        updateEPIs={() => {
          props.commitRearrangedEPIs(this.token, props.rearrangedEpis, props.boxDetails);
          props.getBoxData();
        }}
        getBoxData={this.getBoxData}
        user={this.props.user}
        boxTrigger={this.props.boxTrigger}
      />
    );
  };

  onFailoverInstall = async () => {
    const { boxDetails, failoverInstall, changeAction } = this.props;
    const res = await failoverInstall(this.token, boxDetails._id, boxDetails.vpnAddress);
    if (res) {
      changeAction('Failover Button Press');
    }
  };

  onAssignAvailablePress = async () => {
    const { getAssignedNumbers, boxDetails } = this.props;
    await getAssignedNumbers(
      this.token,
      boxDetails.assignedTo._id,
      boxDetails.epikBoxUser._id,
      true,
    );
  };

  handleReboot = async () => {
    const { setState } = this.props;
    setState({
      confirmModalStatus: true,
      bodyText:
        'Rebooting the EPIK Edge Device will disrupt service.Are you sure you want to reboot this EPIK Edge Device?',
      warningStatus: 'reboot',
    });
  };

  setAdvancedMonitoring = async toggle => {
    const {
      boxDetails,
      advancedMonitoring,
      setState,
      updateBoxData,
      enableAction,
      disableAction,
    } = this.props;
    setState({ enableToggleLoader: true });
    const res = await advancedMonitoring(this.token, {
      toggle,
      companyGroup: boxDetails?.assignedTo?.companyGroup || null,
      vpnAddress: boxDetails.vpnAddress,
      serialNumber: boxDetails.serialNumber,
    });
    if (res) {
      if (boxDetails.advMonitoring) {
        // [Action]- Disable
        disableAction('Advance monitoring change from enable to disable');
      } else {
        // [Action] - Enable
        enableAction('Advance monitoring change from disable to enable');
      }
    }

    if (typeof res === 'boolean') {
      updateBoxData({ ...boxDetails, advancedMonitoring: res });
    }
    setState({ enableToggleLoader: false });
  };

  priStatusCheck = e => {
    const { setState } = this.props;
    setState({ priStatus: e });
  };

  // simStatus = async boxDetails => {
  //   const { eSIMStatus } = this.props;
  //   if (!boxDetails?.myEpik) {
  //     const data = await eSIMStatus(this.token, boxDetails._id);
  //     if (typeof data === 'boolean') {
  //       this.eSIMStatusPing(data);
  //     } else {
  //       this.eSIMStatusPing(null);
  //     }
  //   }
  // };

  eSIMStatusPing = data => {
    const { setState } = this.props;
    setState({ pingStatus: data });
  };

  numberToFilter = async number => {
    const { filterAssignedNumber, getAssignedNumbers, boxDetails } = this.props;
    if (number === '****') {
      await getAssignedNumbers(
        this.token,
        boxDetails.assignedTo._id,
        boxDetails.epikBoxUser._id,
        true,
      );
    } else {
      await filterAssignedNumber(this.token, number, boxDetails.assignedTo._id);
    }
  };

  finalSelectedList = e => {
    const { setState } = this.props;
    setState({ finalSelectedList: e });
  };

  onAnalyticsCall = async () => {
    const { boxDetails, getBoxVtelCdrs } = this.props;
    const { _id, serialNumber } = boxDetails;

    this.setState({
      cdrAnalytics: true,
      loading: true,
    });

    const boxCrds = await getBoxVtelCdrs(this.token, _id);

    this.setState({
      boxCdrs: boxCrds,
      loading: false,
    });
  };

  componentDidUpdate = prevProps => {
    const { boxCdrActivity } = this.props;
    if (boxCdrActivity && prevProps.boxCdrActivity !== boxCdrActivity) {
      this.setState({
        isActivityRowSelected: true,
        boxActivityLogs: boxCdrActivity,
      });
    }
  };

  onCDRModalCancel = async () => {
    const { isActivityRowSelected } = this.state;
    if (isActivityRowSelected) {
      this.setState({ isActivityRowSelected: false });
    } else {
      this.setState({ cdrAnalytics: false, isActivityRowSelected: false });
    }
  };

  toggle = state => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  onBandManagementCall = async (showModel) => {
    console.log('show model enable', showModel)
    this.setState({ loading: true });
    const { fetchTtyData, fetchAndAssignUsbs, boxDetails,getUserDataByToken } = this.props;

    await fetchTtyData(this.token, boxDetails._id);
    await fetchAndAssignUsbs(this.token, boxDetails._id);
    const bandUserData = await  getUserDataByToken(this.token)
    this.setState({
      bandManagementModal
        : showModel,
      loading: false,
      bandUserData
    });
  };

  onBandModalCancel = () => {

    if (
      this.state.bandModelWindow === bandModelWindowsOption.ttyShell
    ) {
      const params = { userId: this.props.user._id, boxId: this.props.boxDetails._id };
      // this.props.end2FASession(this.token, params)
      this.setState({ bandModelWindow: bandModelWindowsOption.faInput, releaseDeviceLock: true, twoFaRes: null });
    }
    else if (this.state.bandModelWindow === bandModelWindowsOption.faInput) {
      this.setState({ bandManagementModal: false, twoFaRes: null });
    } else if (this.state.bandModelWindow === bandModelWindowsOption.faAuth) {
      this.setState({ bandModelWindow: bandModelWindowsOption.faInput, twoFaRes: null });
    }
  };

  onSendFA = async (params) => {
    this.setState({ loading: true });
    params = {
      ...params,
      userId: this.props.user._id,
      // otpPlatform: 'email',
      boxId: window.location.pathname.split('/').pop(),
    };
    
    const shouldShowFaAuthWindow = !params?.otp && params?.authPlatform === '2factorapp';

    if (shouldShowFaAuthWindow) {
      this.setState({ loading: false, bandModelWindow: bandModelWindowsOption.faAuth });
    } else {
      const res = await this.props.sendFA(this.token, params);
      this.setState({ loading: false, ...(res && { bandModelWindow: bandModelWindowsOption.faAuth }) });
    }
  };

  OnAuthenticateFA = async (params) => {
    this.setState({ loading: true });
    params = {
      ...params,
      userId: this.props.user._id,
      boxId: window.location.pathname.split('/').pop(),
    };
    const res = await this.props.authenticate2FA(this.token, params);
    let nextWindow = params.usb === bandModelWindowsOption.webSSH ? bandModelWindowsOption.webSSH : bandModelWindowsOption.ttyShell;
    this.setState({
      loading: false,
      ...(res && { bandModelWindow: nextWindow }),
      twoFaRes: res
    });
  };

  bandManagementStatus = () => {
    const { user = {}, boxDetails = {} } = this.props;
    const showBandManagement = (
      (boxDetails.registered && boxDetails.apiOnline) &&
      (user.role === userRoles.superAdmin || user.role === userRoles.companyGroupManager
        || user.role === userRoles.admin || user.role === userRoles.enterpriseAdmin)
    );
    return showBandManagement;
  };

  bandManagementToggle = (showIcon) => {
    this.setState({ showBandManagementIcon: showIcon })
  }

  oobLoadingHandler = (loading) => {
    this.setState(pre => ({
      ...pre,
      oobLoading: loading
    }))
  }
  OOBManagerHandler = async (needBoxLock) => {
    const res = await this.props.fetchAndAssignUsbs(this.token, this.props.boxDetails._id, needBoxLock);//send to backend
    await this.props.fetchTtyData(this.token, this.props.boxDetails._id);
    await this.props.fetchAvailableOobBTNs(this.token, this.props.boxDetails._id);
    console.log('boxupdated', res)
    this.oobLoadingHandler(false)

    res === true && this.props.updateOOBDetail();
    return res
  }

  render() {
    const { props } = this;
    const {
      isActivityRowSelected,
      cdrAnalytics,
      boxCdrs,
      boxActivityLogs,
      addToolOpen,
      releaseToolOpen,
      portActivityOpen,
      bandManagementModal,
      loading,
      bandModelWindow,
      CallFeatures
    } = this.state;

    const isESeries = this.props.boxDetails?.serialNumber && this.props.boxDetails?.serialNumber?.startsWith('E-')

    return (
      <Col md={isESeries ? 8 : 6} className="text-left box-name-container" style={{ ...(isESeries ? { marginLeft: 'auto', marginRight: 'auto' } : {}) }}>
        {loading && (cdrAnalytics || !bandManagementModal) ? <Spinner customText="Please wait…" /> : null}
        <div className="viewContainer height-view w-100">
          <Row>
            <Col md={12}>
              <RemainingTimer
                onAnalyticsCall={() => this.onAnalyticsCall()}
                onBandManagementCall={() => this.onBandManagementCall(true)}
                showBandManagementIcon={this.state.showBandManagementIcon}
                CallFeaturesModal={() => this.CallFeaturesModal()}
                user={props.user}
                bandModelWindow={bandModelWindow}
                releaseDeviceLock={this.state.releaseDeviceLock}
                parentSetState={(data) => this.setState(data)}
                oobSavedProfiles={prof => this.setState({ oobSavedProfiles: prof })}
              />
              <Row
                style={{
                  padding: '12px 25px 12px 12px',
                  borderBottom: '1px solid #8998ac',
                }}
              >
                <Col md={3} style={{ alignItems: 'center', display: 'flex' }}>
                  <h6
                    style={{ margin: '0px' }}
                    onClick={() => {
                      props.user.role === 'admin' ||
                        props.user.role === 'companyGroupManager' ||
                        props.user.role === 'enterpriseAdmin'
                        ? console.log('not permitted')
                        : !props.deleteMode
                          ? props.showUpdateEpikBox(props.boxDetails)
                          : console.log('delete mode');
                    }}
                  >
                    {props.state.slaveType}
                  </h6>
                </Col>
                <Col md={12}>
                  <BoxPortTabs
                    onModeSelect={this.onModeSelect}
                    user={props.user}
                    portMode={this.props.state.portMode}
                    boxDetails={props.boxDetails}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={12}>
              {props.state.showBox ? (
                this.props.state.portMode !== 'phones' ? (
                  <div
                    className="epik-boxes-container"
                    onClick={
                      this.props.state.portMode === 'epis'
                        ? props.onBoxContainerClick.bind(null)
                        : undefined
                    }
                  >
                    {this.renderPortOrObi()}
                    <DeleteBoxEpiModal
                      title="Delete EPI?"
                      body="Do you really want to delete the EPI?"
                      // onConfirm={() => {
                      //   this.setState({ modalStatus: true });
                      // }}
                      onConfirm={this.onDeleteBoxEpiConfirm}
                      onCancel={props.cancelDeleteEpikBoxEpi}
                      isOpen={props.deleteEpikEpiOpen}
                    />
                  </div>
                ) : (
                  <EpikboxPhones
                    enableBoxEdit={props.state.enableBoxEdit}
                    BoxPhoneClicked={this.handleBoxPhoneDetail}
                    onPhoneDelete={props.handlePhoneDelete}
                    phones={props.boxDetails.phones || []}
                    user={props.user}
                    showPhonesModal={this.showPhonesModal}
                  />
                )
              ) : null}
            </Col>
          </Row>
          {/* )} */}
          {this.state.modalStatus &&
            <AddSecurityCodeModal
              isOpen={this.state.modalStatus}
              onCancel={() => {
                this.setState({ modalStatus: false, });
                if (!this.state.modalStatus) {
                  this.onDeleteBoxEpiConfirm();
                }
              }}
              onConfirm={this.checkSecurityCode}
              securityCode={this.state.modalStatus}
              modalName='EPI'
              featureName='EPI'
            />
          }
          <CdrAnalyticsModal
            headText={
              !isActivityRowSelected ? `Real Time Port Activity` : `CDR Log Analysis`
            }
            isOpen={cdrAnalytics}
            cdrs={boxCdrs}
            isCdrLogs={!!isActivityRowSelected}
            cdrVoipMonLogs={boxActivityLogs}
            onCancel={this.onCDRModalCancel}
          />
          <CallFeaturesModal
            open={this.state.CallFeatures}
            boxDetails={this.state.callFeatureBoxDetails}
            onClose={() => this.setState({ CallFeatures: false })}
            user={props.user}
          />
          {bandManagementModal && <BandManagementModal
            headText={`Out of band management`}
            isOpen={bandManagementModal}
            // isOpen={true}
            onCancel={this.onBandModalCancel}
            sendFA={this.onSendFA}
            twoFaRes={this.state.twoFaRes}
            OnAuthenticateFA={this.OnAuthenticateFA}
            loading={loading}
            bandModelWindow={bandModelWindow}
            oobSavedProfiles={this.state.oobSavedProfiles}
            userDataBand={this.state.bandUserData} 
          />}
        </div>
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
  boxDetails: state.AppState.boxDetails.box,
  engineeringLock: state.AppState.boxDetails.engineeringLock,
  deleteEpikEpiOpen: state.UIState.epikBoxes.deleteEpikEpiOpen,
  boxEpiToDelete: state.UIState.epikBoxes.boxEpiToDelete,
  numbers: state.AppState.numbers,
  selectedObi: state.UIState.epikBoxDetails.selectedObi,
  selectedPort: state.UIState.epikBoxDetails.selectedPort,
  rearrangedEpis: state.UIState.epikBoxDetails.rearrangedEpis,
  rearrangeEPIsState: state.UIState.epikBoxDetails.rearrangeEPIs,
  optionsBoxUpdate: state.UIState.epikBoxes.optionsBoxUpdate.optionsBox,
  lockStatusBox: state.UIState.epikBoxes.lockStatusEpikBox,
  deleteMode: state.AppState.deleteMode,
  boxCdrActivity: state.AppState.boxDetails.boxCdrActivity,
});

const mapDispatchToProps = dispatch => ({
  onSaveSip: (token, body) => dispatch(BoxesActions.onSaveSip(token, body)),
  sipDetails: (token, body) => dispatch(BoxesActions.sipDetails(token, body)),
  resetBulkBoxSession: () => dispatch(resetBulkBoxSession()),
  showUpdateEpikBox: box => dispatch(BoxesActions.showUpdateEpikBox(box)),
  overrideLock: (token, bid) => dispatch(BoxesActions.overrideLock(token, bid)),
  releaseLock: (token, bid) => dispatch(BoxesActions.releaseLock(token, bid)),
  boxLock: (token, bid) => dispatch(BoxesActions.boxLock(token, bid)),
  addLockTime: (token, bid) => dispatch(BoxesActions.addLockTime(token, bid)),
  clearSelectedPort: () => dispatch(BoxesActions.clearBoxDetailsPort()),
  clearBoxDetailsAtaPort: () => dispatch(BoxesActions.clearBoxDetailsAtaPort()),
  clearSelectedObi: () => dispatch(BoxesActions.clearBoxDetailsObi()),
  commitRearrangedEPIs: (token, rearrangedEpis, box) =>
    dispatch(BoxesActions.commitRearrangedEPIs(token, rearrangedEpis, box)),
  openUnassignedObis: () => dispatch(BoxesActions.openUnassignedObis()),
  showDeleteEpikBoxEpi: obi => dispatch(BoxesActions.showDeleteEpikBoxEpi(obi)),
  updateBox: (token, box) => dispatch(BoxesActions.updateEpikBox(token, box)),
  getNumbers: (token, companyId) => dispatch(BoxesActions.getNumbers(token, companyId)),
  showPhoneModal: () => dispatch(BoxesActions.showPhoneModal()),
  setImportNumbers: (token, list) => dispatch(BoxesActions.setImportNumbers(token, list)),
  getBoxDetailById: (token, box) => dispatch(BoxesActions.getBoxDetailById(token, box)),
  getCompanyNumbers: (token, pagination, id, type, disablePaginate) =>
    dispatch(getCompanyNumbers(token, pagination, id, type, disablePaginate)),
  cancelDeleteEpikBoxEpi: obi => dispatch(BoxesActions.cancelDeleteEpikBoxEpi(obi)),
  deleteAction: description => dispatch(deleteAction(description)),
  selectObi: obi => dispatch(BoxesActions.selectBoxDetailsObi(obi)),
  cancelUpdateEpikBox: box => dispatch(BoxesActions.cancelUpdateEpikBox(box)),
  failoverInstall: (token, bid, vpn) => dispatch(BoxesActions.failoverInstall(token, bid, vpn)),
  deleteEpikBoxEpi: (token, obi) => dispatch(BoxesActions.deleteEpikBoxEpi(token, obi)),
  addStep: step => dispatch(addStep(step)),
  popStep: () => dispatch(popStep()),
  setRearrangeEPIs: epis => dispatch(BoxesActions.setRearrangeEPIs(epis)),
  cancelRearrangeEPIs: () => dispatch(BoxesActions.cancelRearrangeEPIs()),
  showBoxConfig: () => dispatch(BoxesActions.openBoxConfig()),
  getAssignedNumbers: (token, cid, uid, priStatus) =>
    dispatch(BoxesActions.getAssignedNumbers(token, cid, uid, priStatus)),
  advancedMonitoring: (token, body) => dispatch(BoxesActions.advancedMonitoring(token, body)),
  selectPort: port => dispatch(BoxesActions.selectBoxDetailsPort(port)),
  selectAta: ata => dispatch(BoxesActions.selectBoxDetailsAta(ata)),
  reloadEpiInfo: (token, boxId) => dispatch(BoxesActions.reloadEpiInfo(token, boxId)),
  unCheckPri: (token, bid) => dispatch(BoxesActions.unCheckPri(token, bid)),
  sendBulkActionsToApi: () => dispatch(sendBulkActionsToApi()),
  filterAssignedNumber: (token, number, bid) =>
    dispatch(BoxesActions.filterAssignedNumber(token, number, bid)),
  setAssignedNumbers: (token, bid, list) =>
    dispatch(BoxesActions.setAssignedNumbers(token, bid, list)),
  eSIMStatus: (token, bid) => dispatch(BoxesActions.eSIMStatus(token, bid)),
  updateBoxData: (token, id, payload) => dispatch(BoxesActions.updateBoxData(token, id, payload)),
  getBoxVtelCdrs: (token, bid) => dispatch(BoxesActions.getBoxVtelCdrs(token, bid)),
  disableAction: description => dispatch(disableAction(description)),
  enableAction: description => dispatch(enableAction(description)),
  changeAction: description => dispatch(changeAction(description)),
  addAction: description => dispatch(addAction(description)),
  sendFA: (token, params) => dispatch(BoxesActions.send2FA(token, params)),
  authenticate2FA: (token, params) => dispatch(BoxesActions.authenticate2FA(token, params)),
  end2FASession: (token, params) => dispatch(BoxesActions.end2FASession(token, params)),
  fetchAndAssignUsbs: (token, boxId, needBoxLock) => dispatch(BoxesActions.fetchAndAssignUsbs(token, boxId, needBoxLock)),
  fetchTtyData: (token, boxId) => dispatch(BoxesActions.fetchTtyData(token, boxId)),
  getAllCompanyNumbers: (token, id, uid, type) => dispatch(getAllNumbers(token, id, uid, type)),
  updateOOBDetail: () => dispatch(BoxesActions.updateOOBDetail()),
  fetchAvailableOobBTNs: (token, boxId) => dispatch(BoxesActions.fetchAvailableOobBTNs(token, boxId)),
  getUserDataByToken: (token) => dispatch(UserActions.getUserDataByToken(token)),
  getLiveCallFeature: (token, bid) => dispatch(BoxesActions.getLiveCallFeature(token, bid)),
  getAllPendingFaxes: (token, filters) => dispatch(FaxActions.getAllPendingFaxes(token, filters)),  
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BoxPortingDetails);
